import React from 'react';


export default props => (
  <div className="RoundedForm" style={props.style}>
    {props.children}
  </div>
)